import {
    ADV_KEYWORDS_SUCCESS,
    ADV_KEYWORDS_LOADING

} from '../actions/AdvKeywordsAction';

const initialState = {
    advKeywordsData: null,
    isLoading: true,
};

const AdvKeywordsReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case ADV_KEYWORDS_SUCCESS:
            return { ...state, advKeywordsData: action.data, isLoading: false };

        case ADV_KEYWORDS_LOADING:
            return { ...state, isLoading: action.isLoading };

        default:
            return state;
    }
};

export default AdvKeywordsReducer;
